<template>
  <div class=" w-full  h-full relative" >
    <div :style="{'width':width + '%'}" class=" h-full space-y-2 relative" v-if="images.length > 0">
      <div
        class="grid gap-2 w-full relative"
        :class="{
          'grid-cols-2': images.length >= 2,
          'grid-cols-1': images.length <= 1,
        }"
      >
        <div
          @click="openImage(0)"
          class="
            w-full
            max-h-80
            h-full
            rounded-tl-xl
            overflow-hidden
            cursor-pointer
          "
          :class="{
            'rounded-bl-xl': images.length == 2,
            'rounded-xl': images.length == 1,
          }"
        >
          <img :src="images[0]" class="w-full h-full object-cover" alt />
        </div>
        <div
          @click="openImage(1)"
          class="
            w-full
            max-h-80
            h-full
            rounded-tr-xl
            overflow-hidden
            cursor-pointer
          "
          v-if="images.length >= 2"
          :class="{ 'rounded-br-xl': images.length == 2 }"
        >
          <img :src="images[1]" class="w-full h-full object-cover" alt />
        </div>
        <div
          class="absolute bottom-4 right-4"
          v-if="images.length <= 2 && showAllButton"
          @click="openImage(0)"
        >
          <button
            class="
              flex
              items-center
              space-x-3
              bg-white
              rounded-md
              py-1
              px-4
              shadow
              hover:bg-gray-200
            "
          >
            <IconDots />
            <span class="text-base text-black font-Work-Sans font-normal"
              >Show all photos</span
            >
          </button>
        </div>
      </div>
      <div
        class="grid gap-2 w-full relative"
        :class="{
          'grid-cols-3': images.length >= 5,
          'grid-cols-2': images.length == 4,
          'grid-cols-1': images.length == 3,
        }"
        v-if="images.length >= 3"
      >
        <div
          @click="openImage(2)"
          class="
            w-full
            h-full
            max-h-64
            rounded-bl-xl
            overflow-hidden
            cursor-pointer
          "
          v-if="images.length >= 3"
          :class="{ 'rounded-br-xl': images.length == 3 }"
        >
          <img :src="images[2]" class="w-full h-full object-cover" alt />
        </div>
        <div
          @click="openImage(3)"
          class="w-full h-full max-h-64 overflow-hidden cursor-pointer"
          v-if="images.length >= 4"
          :class="{ 'rounded-br-xl': images.length == 4 }"
        >
          <img :src="images[3]" class="w-full h-full object-cover" alt />
        </div>
        <div
          @click="openImage(4)"
          class="
            w-full
            h-full
            max-h-64
            rounded-br-xl
            overflow-hidden
            cursor-pointer
          "
          v-if="images.length >= 5"
        >
          <img :src="images[4]" class="w-full h-full object-cover" alt />
        </div>
        <div
          class="absolute bottom-4 right-4"
          @click="openImage(0)"
          v-if="showAllButton"
        >
          <button
            class="
              flex
              items-center
              space-x-3
              bg-white
              rounded-md
              py-1
              px-4
              shadow
              hover:bg-gray-200
            "
          >
            <IconDots />
            <span class="text-base text-black font-Work-Sans font-normal"
              >Show all photos ({{ images.length }})</span
            >
          </button>
        </div>
      </div>
      <div
        class="absolute top-2 right-4 cursor-pointer"
        :class="{
          'text-white hover:text-red-500': !isLove,
          'text-red-500 hover:text-white': isLove,
        }"
        v-if="showHeart"
      >
        <svg
          class="fill-current"
          width="56"
          height="51"
          viewBox="0 0 56 51"
          fill=""
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M40.6 0C35.728 0 31.052 2.25123 28 5.80872C24.948 2.25123 20.272 0 15.4 0C6.776 0 0 6.72589 0 15.2861C0 25.7918 9.52 34.352 23.94 47.3591L28 51L32.06 47.3313C46.48 34.352 56 25.7918 56 15.2861C56 6.72589 49.224 0 40.6 0ZM28.28 43.218L28 43.4959L27.72 43.218C14.392 31.2392 5.6 23.3183 5.6 15.2861C5.6 9.72752 9.8 5.55858 15.4 5.55858C19.712 5.55858 23.912 8.31008 25.396 12.1177H30.632C32.088 8.31008 36.288 5.55858 40.6 5.55858C46.2 5.55858 50.4 9.72752 50.4 15.2861C50.4 23.3183 41.608 31.2392 28.28 43.218Z"
          />
        </svg>
      </div>
    </div>
    <div
      v-show="isOpen"
      class="
        absolute
        top-0
        left-0
        h-screen
        w-full
        bg-gray-500
        z-50
        bg-opacity-95
      "
    >
      <div class="w-full h-full flex items-center space-x-4 py-2 px-2">
        <div class="cursor-pointer hover:text-purple-200" @click="BackStep">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="80"
            height="80"
            fill="currentColor"
            class="bi bi-arrow-left"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
            />
          </svg>
        </div>
        <div
          class="
            w-full
            h-full
            bg-gray-200
            opacity-75
            rounded-md
            shadow-lg
            overflow-hidden
          "
        >
          <img
            v-if="images.length > 0"
            :src="images[selectedImage]"
            alt=""
            class="w-full h-full"
          />
        </div>
        <div class="cursor-pointer hover:text-purple-200" @click="NextStep">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="80"
            height="80"
            fill="currentColor"
            class="bi bi-arrow-right"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
            />
          </svg>
        </div>
      </div>
      <div
        class="absolute top-2 right-4 hover:text-purple-200 cursor-pointer"
        @click="closeImage"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="50"
          height="50"
          fill="currentColor"
          class="bi bi-x-circle"
          viewBox="0 0 16 16"
        >
          <path
            d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
          />
          <path
            d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
          />
        </svg>
      </div>
    </div>
  </div>
</template>


<script>
import IconDots from "./icons/IconDots.vue";
export default {
  props: {
    width: {
      type: [Number, String],
      default: "100",
    },
    images: {
      type: Array,
      required: true,
    },
    showHeart: {
      type: Boolean,
      default: true,
      required: false,
    },
    isLove: {
      type: Boolean,
      default: false,
      required: false,
    },
    showAllButton: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  data() {
    return {
      selectedImage: 0,
      isOpen: false,
    };
  },
  methods: {
    openImage(index) {
      this.isOpen = true;
      this.selectedImage = index;
    },
    closeImage() {
      this.isOpen = false;
    },
    NextStep() {
      if (this.selectedImage < this.images.length - 1) {
        this.selectedImage++;
      } else {
        this.selectedImage = 0;
      }
    },
    BackStep() {
      if (this.selectedImage > 0) {
        this.selectedImage--;
      } else {
        this.selectedImage = this.images.length - 1;
      }
    },
  },
  components: {
    IconDots,
  },
};
</script>